import {PageHeader, ColourSolid, FullWidthSidebar, useLayout, useNotifications} from "@twigsby/frontend-framework";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import CreateStandaloneSendForm from "../../Components/SendsAdmin/CreateSendsForm";
import SendsNavigation from "../../Components/SendMail/Shared/Controls/SendsNavigation";
import {faFloppyDisk} from "@fortawesome/pro-solid-svg-icons/faFloppyDisk";
import {createSendsPage, SendsPageItemType, SendsPagesUpdateType, useUpdateSendsData} from "@twigsby/client-data";
import {useSite} from "../../Providers/SiteInterfaceProvider";

const CreateSendsPage = () => {
    const { t } = useTranslation();

    const { addNotification } = useNotifications();
    const { isLarge } = useLayout();
    const { currentLocale, updatePageMeta } = useSite();

    const [ savingData, setSavingData] = useState<boolean>(false);
    const [ saveError, setSaveError] = useState<any>();
    const [ saveResp, setSaveResp ] = useState(null);

    const sendsTemplates = useUpdateSendsData();

    const sendsCreateRef = useRef<any>();
    const sendMailNavigationRef = useRef<any>();

    const HandleSave = async (newData: SendsPageItemType) => {
        setSavingData(true);

        await createSendsPage(newData)
            .then((resp: any) => {
                sendsTemplates.mutate({
                    updateType: SendsPagesUpdateType.CREATE,
                    newData: newData
                });

                addNotification({
                    title: t('results.sendsCreated'),
                    icon: faFloppyDisk,
                    colour: ColourSolid.Success
                });

                setSaveResp(resp);
            })
            .catch((e: any) => {
                setSaveError(e.response.data);
            })
            .finally(() => setSavingData(false));
    }

    useEffect(() => {
        updatePageMeta({
            title: t('sends.create.title')
        });
    }, [currentLocale]);

    return (
        <FullWidthSidebar
            ref={sendsCreateRef}
            navigationComponent={
                <SendsNavigation
                    title={t('sends.create.title')}
                    ref={sendMailNavigationRef}
                />
            }
            extraContentClass={`flex-column `}
        >
            {isLarge && (
                <PageHeader title={t('sends.create.title')} />
            )}

            <div className={'pt-xl pb-xl p-md'}>
                <div className={'row mb-xxxl'}>
                    <div className={'col-xs-12 col-xl-6 col-xxl-5 '}>
                        <CreateStandaloneSendForm
                            saveCallback={HandleSave}
                            saveResponse={saveResp}
                            savingData={savingData}
                            error={saveError}
                        />
                    </div>

                </div>
            </div>

        </FullWidthSidebar>
    )
}

export default CreateSendsPage
